var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1558 0.000842068L-0.00390625 36.9474V69.991L35.09 34.8312L70.0027 -0.015625L35.1558 0.000842068Z",
    fill: "url(#paint0_linear_1930_22364)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00390625 69.9996L35.09 34.8398L70.0027 69.9996H-0.00390625Z",
    fill: "url(#paint1_linear_1930_22364)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00390625 0.000976562H35.1558L-0.00390625 36.9475V0.000976562Z",
    fill: "url(#paint2_linear_1930_22364)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1930_22364",
    x1: -11.7869,
    y1: 64.3588,
    x2: 53.3533,
    y2: -0.78139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#C757BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#CD5CA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#E8744F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#F88316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1930_22364",
    x1: 22.3435,
    y1: 82.6307,
    x2: 54.0943,
    y2: 50.8799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#00AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#5282FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1930_22364",
    x1: -0.835553,
    y1: 19.3182,
    x2: 21.4295,
    y2: -2.95507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#00AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#5282FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.052c06c07da9fbfefda0d47ed2f26646.svg";
export { ForwardRef as ReactComponent };